import * as React from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import Calendar from '@Components/MuiWrappers/Calendar';
import Input from '@mui/material/TextField';
import { useState, useEffect } from 'react';

export default function PopoverMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const today = new Date();
    const calendarMin = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate(), 0, 0, 0, 0);
    const calendarMax = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 0);
    const minCalendarId = 'min-date-calendar';
    const maxCalendarId = 'max-date-calendar';

    const [minCalendarDisabled, setMinCalendarDisabled] = useState(props.DisableMinCalendar || (props.MaximumDate && !props.MinimumDate));
    const [maxCalendarDisabled, setMaxCalendarDisabled] = useState(props.DisableMaxCalendar || (!props.MaximumDate && props.MinimumDate));
    const [minDate, setMinDate] = useState(props.MinimumDate ? new Date(props.MinimumDate) : (minCalendarDisabled ? calendarMin : new Date(today.getFullYear() - 5, today.getMonth(), today.getDate(), 0, 0, 0, 0)));
    const [maxDate, setMaxDate] = useState(props.MaximumDate ? new Date(props.MaximumDate) : calendarMax);
    const [minimum, setMinimum] = useState(props.Minimum || '');
    const [maximum, setMaximum] = useState(props.Maximum || '');
    const [label, setLabel] = useState(props.Label);

    const onMinChange = (date) => {
        setMinDate(date);
        enableMaxCalendar();
    };

    const onMaxChange = (date) => {
        setMaxDate(date);
        enableMinCalendar();
    };

    const enableMinCalendar = () => {
        if (!props.DisableMinCalendar) {
            setMinCalendarDisabled(false);
        }
    };

    const enableMaxCalendar = () => {
        if (!props.DisableMaxCalendar) {
            setMaxCalendarDisabled(false);
        }
    };

    const saveRange = () => {
        if (props.IsYear) {
            props.onChange({ minimum, maximum });

            if (minimum || maximum) {
                setLabel(minimum + ' - ' + maximum);
            }        
        }

        else {
            props.onChange({ minDate, maxDate });
            setLabel(minDate.toLocaleDateString() + ' - ' + maxDate.toLocaleDateString());
        }
        handleClose();
    };

    const id = open ? 'simple-popover' : undefined;

    const sx = {
        '& .MuiOutlinedInput-root.Mui-focused': {
            '& > fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.87)'
            }
        },
        backgroundColor: 'white',
        input: {
            fontSize: '14px',
            color: 'rgba(0, 0, 0, 0.87)'
        },
        button: {
            marginRight: '10px'
        },
        svg: {
            width: '15px',
            height: '15px'
        },
        width: '100%',
        height: '37.13px'
    };

    return (
        <div className='drilldown__button-container'>
            <Button aria-describedby={id} variant="contained" onClick={handleClick} className='drilldown__search-button' disabled={props.disabled} sx={{ backgroundColor: 'white', color: 'rgba(0, 0, 0, 0.87)', fontWeight: 'normal', justifyContent: 'space-between', "&.Mui-disabled": {backgroundColor: 'white'} }}>
                <span>{label}</span>
                <span className='shp__trigger-arrow'>
                    <i className={`fas ${(open ? 'fa-caret-up' : 'fa-caret-down')}`} />
                </span>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                className='drilldown__popover-container'
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <div className='drilldown__popover'>
                    {props.IsYear ?
                        <div className='faceted-range'>
                            <div className='faceted-range-input-container'>
                                <label htmlFor={'range-input-min-' + props.FieldName} className='visually-hidden'>Year From</label>
                                <input
                                    id={'range-input-min-' + props.FieldName}
                                    value={minimum}
                                    onChange={(e) => setMinimum(e.target.value)}
                                    type='tel'
                                    placeholder='Year Min'
                                />
                            </div>
                            <span className='faceted-range-divider'>-</span>
                            <div className='faceted-range-input-container'>
                                <label htmlFor={'range-input-max-' + props.FieldName} className='visually-hidden'>Year To</label>
                                <input
                                    id={'range-input-max-' + props.FieldName}
                                    value={maximum}
                                    onChange={(e) => setMaximum(e.target.value)}
                                    type='tel'
                                    placeholder='Year Max'
                                />
                            </div>
                        </div>
                        :
                        <div className='faceted-range'>
                            <div className='faceted-range-input-container'>
                                <label htmlFor={minCalendarId} className='visually-hidden'>Date From</label>
                                <Calendar
                                    id='FromDate'
                                    name='FromDate'
                                    value={minDate}
                                    onChange={onMinChange}
                                    inputFormat='MM/dd/yyyy'
                                    minDate={calendarMin}
                                    InputAdornmentProps={{
                                        sx: {
                                            margin: '0px'
                                        }
                                    }}
                                    sx={sx}
                                />
                            </div>
                            <span className='faceted-range-divider'>-</span>
                            <div className='faceted-range-input-container'>
                                <label htmlFor={maxCalendarId} className='visually-hidden'>Date To</label>
                                <Calendar
                                    id='FromDate'
                                    name='FromDate'
                                    value={maxDate}
                                    onChange={onMaxChange}
                                    inputFormat='MM/dd/yyyy'
                                    maxDate={calendarMax}
                                    InputAdornmentProps={{
                                        sx: {
                                            margin: '0px'
                                        }
                                    }}
                                    sx={sx}
                                />
                            </div>
                        </div>
                    }
                    <Button variant="contained" className='drilldown__save-button' onClick={saveRange}>
                        Save
                    </Button>
                </div>
            </Popover>
        </div>
    );
}
